import { render, staticRenderFns } from "./ProfessionalAccountStatus.vue?vue&type=template&id=91a1e298"
import script from "./ProfessionalAccountStatus.vue?vue&type=script&lang=js"
export * from "./ProfessionalAccountStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports